import type { Components } from 'react-markdown';

/** Inline markdown / HTML images in chat content — natural aspect ratio, no crop. */
export const MarkdownChatImage: NonNullable<Components['img']> = ({
  src,
  alt,
  node: _node,
  ...props
}) => (
  <img
    src={src}
    alt={alt ?? ''}
    className="my-2 h-auto max-w-full object-contain"
    {...props}
  />
);
